import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const reflexiveVerbsQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.VERBOS_REFLEXIVOS,
        questionText: "¿Cuál es la forma correcta de la oración reflexiva? 'Yo ___ despierto temprano todos los días.'",
        options: ["me", "te", "se", "nos"],
        correctAnswerIndex: 0,
        explanation: "'Despertarse' es un verbo reflexivo, y para 'yo', el pronombre reflexivo correcto es 'me'."
    },
    {
        category: QuizCategory.VERBOS_REFLEXIVOS,
        questionText: "¿Cuál es la forma correcta del verbo reflexivo? 'Ella ___ maquilla antes de salir.'",
        options: ["nos", "me", "te", "se"],
        correctAnswerIndex: 3,
        explanation: "'Maquillarse' es un verbo reflexivo, y para 'ella', el pronombre reflexivo correcto es 'se'."
    },
    {
        category: QuizCategory.VERBOS_REFLEXIVOS,
        questionText: "¿Cuál es la forma correcta del verbo reflexivo? 'Mañana, él ___ (levantarse) a las seis de la mañana.'",
        options: ["se levantará", "se levantó", "se levanta", "se duerme"],
        correctAnswerIndex: 0,
        explanation: "'Se levantará' es el futuro de indicativo para 'él'. Se usa para referirse a una acción que sucederá en el futuro."
    },
    {
        category: QuizCategory.VERBOS_REFLEXIVOS,
        questionText: "¿Cuál es la forma correcta del verbo reflexivo? 'Antes de salir al trabajo, yo ___ (afeitarse) bien.'",
        options: ["me afeito", "me afeité", "me afeitaré", "me afeitaría"],
        correctAnswerIndex: 0,
        explanation: "'Me afeito' es el presente de indicativo para 'yo'. Se usa cuando hablamos de una acción habitual que sucede en el presente."
    },
    {
        category: QuizCategory.VERBOS_REFLEXIVOS,
        questionText: "¿Cuál es la forma correcta del verbo reflexivo? 'Él ___ afeita antes de ir al trabajo.'",
        options: ["se", "me", "te", "nos"],
        correctAnswerIndex: 0,
        explanation: "'Afeitarse' es un verbo reflexivo, y para 'él', el pronombre reflexivo correcto es 'se'."
    },
    {
        category: QuizCategory.VERBOS_REFLEXIVOS,
        questionText: "¿Cuál es la forma correcta del verbo reflexivo? 'Cada mañana, vosotros ___ (afeitarse) antes de salir a trabajar.'",
        options: ["os afeitáis", "os afeitaron", "os afeitaréis", "os afeitaron"],
        correctAnswerIndex: 0,
        explanation: "'Os afeitáis' es el presente de indicativo para 'vosotros'. Se usa para hablar de acciones habituales en el presente."
    },
    {
        category: QuizCategory.VERBOS_REFLEXIVOS,
        questionText: "¿Cómo se conjuga el verbo reflexivo 'vestirse' en la forma correcta para 'ella'?",
        options: ["se viste", "se vestía", "se vistió", "se vestirá"],
        correctAnswerIndex: 0,
        explanation: "La forma correcta es 'se viste', porque estamos hablando de una acción habitual en presente."
    }
];

export default reflexiveVerbsQuestions;